import React from "react";
import { Box, Typography } from "@mui/material";
import { DisabledAccountIcon } from "../../../src/icons/index";

const DisabledAccountOverlay = ({ zIndex = 900 }) => {
  return (
    <Box
      sx={{
        position: "absolute",
        inset: 0,
        backgroundColor: "rgba(246, 239, 227, 0.8)",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        backdropFilter: "blur(2px)",
        zIndex,
        px: 2,
        py: 2,
      }}
    >

      <Box
        sx={{
          backgroundColor: "rgba(246, 239, 227, 0.95)",
          border: "2px solid #C89A3C",
          borderRadius: "14px",
          overflow: "hidden",
          py: 5,
          px: 2,
          width: "100%",
          maxWidth: 520,
        }}
      >

        {/* Center content */}
        <Box
          sx={{
            zIndex: 2,
            height: "100%",
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            justifyContent: "center",
            textAlign: "center",
            px: 3,
          }}
        >
          {/* Icon */}

          <Box sx={{ background: '#fff', padding: '10px', borderRadius: '100px', boxShadow: '0 0 10px rgba(0,0,0,0.3)' }}>
            <DisabledAccountIcon sx={{ fontSize: 36, color: "#7A531E" }} />
          </Box>


          {/* Title */}
          <Typography
            sx={{
              fontFamily: "ivypresto-headline",
              fontSize: "26px",
              fontWeight: 600,
              color: "#3A2A1F",
              mb: 1,
            }}
          >
            Disabled Account
          </Typography>

          {/* Description */}
          <Typography
            sx={{
              fontSize: "14px",
              color: "#5F6368",
              maxWidth: 360,
            }}
          >
            This profile has been removed because it does not meet our platform
            standards.
          </Typography>
        </Box>
      </Box>
    </Box>
  );
};

export default DisabledAccountOverlay;
